// extracted by mini-css-extract-plugin
export default {"root":"Projects_root__DJFoq","projects":"Projects_projects__Udwv6","actions":"Projects_actions__-CsZr","button":"Projects_button__EaH3f"};